module.exports = __webpack_public_path__ + "assets/retina_LDropPerpDetailed.bec1d3978f6a288a354607b974d3a351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LDropPerpDetailed.png
// module id = 685
// module chunks = 0